import { Dispatch, SetStateAction, useState } from "react";
import { useTranslation } from "react-i18next";
import Validator, { ValidationError } from "fastest-validator";
import type { TFunction } from "i18next";

interface UseOcEmailInputResult {
  value: string;
  setValue: Dispatch<SetStateAction<string>>;
  error: boolean;
  setError: Dispatch<SetStateAction<boolean>>;
  helperText: string;
  setHelperText: Dispatch<SetStateAction<string>>;
  isValid: () => boolean;
  validate: () => void;
}

const validator = new Validator();

export const useOcEmailInput = (): UseOcEmailInputResult => {
  const { t }: { t: TFunction } = useTranslation();

  const emailSchema = {
    email: {
      type: "email",
      messages: {
        email: t("MY_HR_ERROR_MESSAGE_WRONG_EMAIL_FORMAT"),
        emailEmpty: t("OC_ERROR_MESSAGE_EMAIL_IS_REQUIRED"),
      },
    },
  };

  const checkEmail = validator.compile<{ email: string }>(emailSchema);

  const [value, setValue] = useState<string>("");
  const [error, setError] = useState<boolean>(false);
  const [helperText, setHelperText] = useState<string>("");

  const isValid = (): boolean => {
    const result = checkEmail({ email: value });
    return result === true;
  };

  const validate = (): void => {
    setError(false);
    setHelperText("");
    const result = checkEmail({ email: value });
    if (result !== true) {
      (result as ValidationError[]).forEach((err) => {
        if (err.field === "email") {
          setError(true);
          setHelperText(err.message as string);
        }
      });
    }
  };

  return {
    value,
    setValue,
    error,
    setError,
    helperText,
    setHelperText,
    isValid,
    validate,
  };
};

export default useOcEmailInput;
